// src/features/companyDetailSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

// Thunk to fetch a single company by doc ID from "companies"
export const fetchCompanyById = createAsyncThunk(
  "companyDetail/fetchCompanyById",
  async (companyId) => {
    const docRef = doc(db, "companies", companyId);
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) {
      throw new Error(`No company found for ID: ${companyId}`);
    }
    return { id: companyId, data: docSnap.data() };
  }
);

const companyDetailSlice = createSlice({
  name: "companyDetail",
  initialState: {
    companyById: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanyById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompanyById.fulfilled, (state, action) => {
        state.loading = false;
        const { id, data } = action.payload;
        // Store each company doc under its ID
        state.companyById[id] = data;
      })
      .addCase(fetchCompanyById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default companyDetailSlice.reducer;
